import request from "arcdynamic-request";
import { backendServicesUrl } from "../consts/env";
import { TEAM, FIRMS, OFFICES, TEAM_LICENSES, PRODUCT_TYPES, MARKETS, TERRITORIES_V2, ASSIGNED_TERRITORIES, AGENTS, BUYERS, TENANTS, UNDERWRITING_TENANTS, UNDERWRITING_TENANT_TYPES, TEAM_MEMBER_CRM_CREDENTIALS, SELLERS, TERRITORIES_STNL, TERRITORIES_MTNL, VENDORS, LENDERS, INVESTORS, INVESTOR_HOT_LIST, HSC_LOAN_QUOTES } from "../consts/tables";
import { TERRITORY_MASTER, TERRITORY_AGENT_MAPING } from "../consts/queries";

// read
export function getData({tableCode, options}) {
    const url = backendServicesUrl;
    return request(url, {
        service: 'arcimedes',
        action: 'open.datasource.table.Data.getData',
        params: ['code', tableCode, options]
    });
}

// create, update, delete
export function manageData({tableCode, data}) {
    const url = backendServicesUrl;
    return request(url, {
        service: 'arcimedes',
        action: 'open.datasource.table.Data.updateByTableCode',
        params: [tableCode, {
            value: data, // data has to be array
        }]
    });
}